var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 2.66666C10.0098 2.66666 8.66667 4.0098 8.66667 5.66666C8.66667 6.21894 9.11438 6.66666 9.66667 6.66666C10.219 6.66666 10.6667 6.21894 10.6667 5.66666C10.6667 5.11437 11.1144 4.66666 11.6667 4.66666H17C17.5523 4.66666 18 5.11437 18 5.66666V18.3333C18 18.8856 17.5523 19.3333 17 19.3333H11.6667C11.1144 19.3333 10.6667 18.8856 10.6667 18.3333C10.6667 17.781 10.219 17.3333 9.66667 17.3333C9.11438 17.3333 8.66667 17.781 8.66667 18.3333C8.66667 19.9902 10.0098 21.3333 11.6667 21.3333H17C18.6569 21.3333 20 19.9902 20 18.3333V5.66666C20 4.0098 18.6569 2.66666 17 2.66666H11.6667Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11L7.41421 11L8.70711 9.7071C9.09763 9.31657 9.09763 8.68341 8.70711 8.29288C8.31658 7.90236 7.68342 7.90236 7.29289 8.29288L4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071L7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071C9.09763 15.3166 9.09763 14.6834 8.70711 14.2929L7.41421 13H15Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/iconExit.a490c86d8c28ca8217155f2a570e1d03.svg";
export { ForwardRef as ReactComponent };